import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const VehicleTypeListComponent = loadable(
  () => import("../../components/VehicleType/VehicleTypeList")
);

const VehicleTypeList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Vehicle Type
        </span>
      </div>
      <VehicleTypeListComponent />
    </>
  );
};

export default VehicleTypeList;
